import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import VideoCard from "../components/VideoCard";

export default function Partner() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/partners/${slug}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [slug]);

  if (!data) return <div className="min-h-screen pt-32 text-center text-white/60">Loading partner…</div>;
  const p = data.partner;

  return (
    <div data-testid="partner-page" className="min-h-screen">
      <section className="relative h-80 md:h-96 overflow-hidden">
        {p.banner_url && <img src={p.banner_url} alt="" className="absolute inset-0 w-full h-full object-cover" />}
        <div
          className="absolute inset-0"
          style={{ background: `linear-gradient(180deg, ${p.brand_color}33 0%, rgba(10,10,10,0.4) 50%, #0A0A0A 100%)` }}
        />
        <div className="relative h-full flex flex-col justify-end px-4 sm:px-8 md:px-12 pb-8">
          <div className="flex items-end gap-5">
            {p.logo_url && <img src={p.logo_url} alt={p.name} className="w-24 h-24 md:w-28 md:h-28 rounded-2xl border-2 border-white/20 object-cover shadow-2xl" />}
            <div>
              <div className="text-xs uppercase tracking-[0.3em] font-bold" style={{ color: p.brand_color }}>Partner Channel</div>
              <h1 className="font-display font-black text-5xl md:text-6xl text-white tracking-tighter mt-1">{p.name}</h1>
              <p className="text-white/80 mt-2 text-sm md:text-base max-w-2xl">{p.tagline}</p>
            </div>
          </div>
        </div>
      </section>

      <div className="px-4 sm:px-8 md:px-12 py-10 max-w-7xl mx-auto">
        <p className="text-white/80 max-w-3xl">{p.description}</p>

        {data.creators?.length > 0 && (
          <section className="mt-10">
            <h2 className="font-display font-bold text-2xl text-white mb-4">Channel creators</h2>
            <div className="flex flex-wrap gap-4">
              {data.creators.map((c) => (
                <div key={c.user_id} className="tv-glass rounded-xl p-3 flex items-center gap-3">
                  <img src={c.picture} alt="" className="w-12 h-12 rounded-full object-cover" />
                  <div>
                    <div className="flex items-center gap-1">
                      <div className="text-white font-semibold">{c.name}</div>
                      {c.is_verified && <span className="text-tv-brand" title="Verified">✓</span>}
                    </div>
                    <div className="text-xs text-white/50 uppercase tracking-wider">{c.role.replace("_", " ")}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        <section className="mt-12">
          <h2 className="font-display font-bold text-2xl text-white mb-4">Latest from {p.name}</h2>
          {data.videos.length === 0 ? (
            <div className="text-white/60">No content in this channel yet.</div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {data.videos.map((v) => <VideoCard key={v.id} item={v} fullWidth />)}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
